import type { FC, PropsWithChildren } from 'react';

import XbetLogo from 'assets/icons/1xbet/1xbet-logo.png';

import { SwitchLocale } from '../../switch-locale';

const BaseCard: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mx-auto md:m-auto flex flex-col items-start gap-4 max-w-[500px] w-full">
      <div className="flex justify-between items-center w-full">
        <img src={XbetLogo} className="w-[120px] md:w-[160px]" alt="1xbet logo" />
        <div className="block md:hidden">
          <SwitchLocale />
        </div>
      </div>
      <div className="h-[1px] w-full bg-1xbet-gray-200 md:hidden" />
      <div className="w-full md:border border-1xbet-gray-200 md:p-8 rounded-xsmall">{children}</div>
    </div>
  );
};

export { BaseCard };
